import { useState, useCallback } from 'react';
import api from '../../../services/api';

export const useVouchers = () => {
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchVouchers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/vouchers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVouchers(response.data || []);
      return response.data || [];
    } catch (err) {
      console.error('Erreur lors de la récupération des vouchers:', err);
      setError(err.message);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  const acceptVoucher = useCallback(async (voucherId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.put(`/vouchers/${voucherId}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Mettre à jour la liste des vouchers
      setVouchers(prevVouchers => 
        prevVouchers.map(v => 
          v.id === voucherId ? { ...v, is_used: true } : v
        )
      );
      
      return true;
    } catch (err) {
      console.error('Erreur lors de l\'acceptation du bon:', err);
      setError(err.message);
      return false;
    }
  }, []);

  return {
    vouchers,
    loading,
    error,
    fetchVouchers,
    acceptVoucher
  };
};
